import {useTranslation} from '@aboutyou/i18n';
import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {
  COLORS,
  ContentPopperProps,
  FONT_SIZES,
  FONT_WEIGHTS,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {ProductDetailsModal} from './ProductDetailsModal';
import {getProductDetailsSlotName} from './constants';

interface ProductDetailsSlotProps {
  checkoutItemId: string;
  productId: number;
  LayoutComponent: ContentPopperProps['LayoutComponent'];
}

export const ProductDetailsSlot: React.FC<ProductDetailsSlotProps> = ({
  checkoutItemId,
  productId,
  LayoutComponent,
}) => {
  const {t} = useTranslation();
  const {isOpen, open, cancel} = useOpenedStateManager(
    `product-details-${checkoutItemId}`,
  );

  return (
    <div
      slot={getProductDetailsSlotName(checkoutItemId)}
      data-testid={`product-details-slot-${checkoutItemId}`}
    >
      <DetailsLink
        onClick={() => open()}
        data-testid={`product-details-link-${checkoutItemId}`}
        type="button"
      >
        {t('More Product Details')}
      </DetailsLink>

      <ProductDetailsModal
        open={isOpen}
        onClose={() => cancel()}
        productId={productId}
        LayoutComponent={LayoutComponent}
      />
    </div>
  );
};

const DetailsLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 1.5;
  text-decoration: underline;
  text-align: left;
  color: ${COLORS['Grey.Shade500']};

  &:hover {
    opacity: 0.7;
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.Black};
    outline-offset: 2px;
  }

  &:active {
    opacity: 0.5;
  }
`;
